import type { ReactNode } from 'react'
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react'

export const PAGE_SIZES = [10, 50, 100, 500] as const

const nav =
  'rounded-md border border-b4l-border px-2 py-1 text-b4l-text-muted hover:bg-b4l-bg-soft disabled:opacity-40'

export function Pagination({
  page,
  pageSize,
  total,
  onPage,
  onPageSize,
  unit = 'rânduri',
  summary,
}: {
  page: number
  pageSize: number
  total: number
  onPage: (p: number) => void
  onPageSize: (n: number) => void
  unit?: string
  /** Totaluri sau alte cifre calculate pe TOT ce trece de filtre, nu doar pe pagina. */
  summary?: ReactNode
}) {
  const pages = Math.max(1, Math.ceil(total / pageSize))
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1
  const to = Math.min(page * pageSize, total)

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-t border-b4l-border px-4 py-2.5 text-[12px] text-b4l-text-muted">
      <div className="flex items-center gap-2">
        <span>Per pagină:</span>
        <select
          value={pageSize}
          onChange={(e) => {
            onPageSize(Number(e.target.value))
            onPage(1) // altfel ai putea ramane pe o pagina care nu mai exista
          }}
          className="rounded-md border border-b4l-border px-2 py-1 text-[12px] outline-none focus:border-b4l-green"
        >
          {PAGE_SIZES.map((n) => (
            <option key={n} value={n}>
              {n}
            </option>
          ))}
        </select>
      </div>

      <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
        <span>
          {from.toLocaleString('ro-RO')}–{to.toLocaleString('ro-RO')} din{' '}
          <b className="text-b4l-text">{total.toLocaleString('ro-RO')}</b> {unit} · pagina {page} / {pages}
        </span>
        {summary}
      </div>

      <div className="flex items-center gap-1">
        <button onClick={() => onPage(1)} disabled={page <= 1} className={nav} title="Prima pagină">
          <ChevronsLeft size={14} />
        </button>
        <button onClick={() => onPage(page - 1)} disabled={page <= 1} className={nav} title="Înapoi">
          <ChevronLeft size={14} />
        </button>
        <button onClick={() => onPage(page + 1)} disabled={page >= pages} className={nav} title="Înainte">
          <ChevronRight size={14} />
        </button>
        <button onClick={() => onPage(pages)} disabled={page >= pages} className={nav} title="Ultima pagină">
          <ChevronsRight size={14} />
        </button>
      </div>
    </div>
  )
}
